import React from 'react';
import ReactDOM from 'react-dom/client';
import Particles from 'react-tsparticles';
import { ConfigProvider, theme } from 'antd';

import './login.scss';
import logoSvg from 'common/assets/images/dwn-logo-vertical.svg';
import particlesConfig from '~/login/config.particles';
import LoginForm from '~/login/form';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.Fragment>
    <Particles id="particles-js" options={particlesConfig} />
    <ConfigProvider
      theme={{
        algorithm: theme.defaultAlgorithm,
        token: {
          colorPrimary: '#2386b4',
          borderRadius: 6,
          fontSize: 14,
        },
        components: {
          Form: {
            labelColor: '#fff',
          },
          Input: {
            colorBgContainer: 'rgba(255, 255, 255, 0.95)',
            colorBorder: 'rgba(255, 255, 255, 0.3)',
            colorText: '#000',
            colorTextPlaceholder: 'rgba(0, 0, 0, 0.45)',
          },
          Select: {
            colorBgContainer: 'rgba(255, 255, 255, 0.95)',
            colorBorder: 'rgba(255, 255, 255, 0.3)',
            colorText: '#000',
            colorTextPlaceholder: 'rgba(0, 0, 0, 0.45)',
          },
          Button: {
            colorPrimary: '#2386b4',
            algorithm: true,
          },
        },
      }}
    >
      <div className="text">
        <div className="logo">
          <img src={logoSvg} alt="Darwin logo" />
        </div>
        <LoginForm />
      </div>
    </ConfigProvider>
  </React.Fragment>,
);
